import React from 'react';
import {HashRouter as Router, Route, Routes} from 'react-router-dom'
import './App.css';
import Home from "./pages/Home";
import Footer from "./components/Footer";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`

const BodyWrapper = styled.div`
    flex: 1;
`

const FooterWrapper = styled.div`
    flex: 0;
    margin-bottom: 20px;
`

function App() {
    return (
        <Router>
            <Container>
                <BodyWrapper>
                    <Routes>
                        <Route path="/" element={<Home />} />
                    </Routes>
                </BodyWrapper>
                <FooterWrapper>
                    <Footer />
                </FooterWrapper>
            </Container>
        </Router>
    );
}

export default App;
